<template>
  <div v-if="specification_info" class="specification_info">
    <div class="specification_info__left">
      <div class="specification_info__left__wrap" ref="content">
        <div class="main_info" ref="main_info">
          <div class="line row">
            <div class="col-md-1 col-sm-1">
              <fg-input v-model="specification_info.id" type="text" :label="translate('specification.id')"
                        :placeholder="translate('specification.id')" :readonly="true" />
            </div>

            <div class="col-md-2 col-sm-2">
              <fg-input v-model="specification_info.total_devices" type="text" :label="translate('specification.total_devices')"
                        :placeholder="translate('specification.total_devices')" :readonly="true" />
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="specification_info.date" type="text"
                        :label="translate('specification.date')"
                        :placeholder="translate('specification.status')" :readonly="true" />
            </div>
          </div>

          <div class="line row">
            <div class="col-md-2 col-sm-2">
              <fg-input v-model="specification_info.spec_number" type="text" :label="translate('specification.spec_number')"
                        :placeholder="translate('specification.spec_number')" />
            </div>

            <div class="col-md-2 col-sm-2">
              <fg-input v-model="specification_info.cost" type="text" :label="translate('specification.cost')"
                        :placeholder="translate('specification.cost')" />
            </div>

            <div class="col-md-4 col-sm-4">
              <fg-input v-model="specification_info.name" type="text" :label="translate('specification.name')"
                        :placeholder="translate('specification.name')" />
            </div>

            <div class="col-md-4 col-sm-4">
              <div class="form-group">
                <label> {{ translate('specification.client') }} </label>
                <tree-select v-model="specification_info.client_id" :options="client_list"
                             :placeholder="translate('specification.user')" :clearable="false" :searchable="false" :disabled="true"/>
              </div>
            </div>
          </div>

          <div class="line row">
            <div class="col-md-3 col-sm-3">
              <div class="form-group">
                <label> {{ translate('specification.status') }} </label>
                <tree-select v-model="specification_info.status" :options="status_list"
                             :placeholder="translate('specification.status')" :clearable="false" :searchable="false"/>
              </div>
            </div>

            <div class="col-md-3 col-sm-3">
              <div class="form-group">
                <label> {{ translate('specification.type') }} </label>
                <tree-select v-model="specification_info.type" :options="type_list"
                             :placeholder="translate('specification.type')" :clearable="false" :searchable="false" :disabled="check_status"/>
              </div>
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="date_created" type="text" :label="translate('specification.created_at')"
                        :placeholder="translate('specification.created_at')" :readonly="true" />
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="date_updated" type="text" :label="translate('specification.updated_at')"
                        :placeholder="translate('specification.updated_at')" :readonly="true" />
            </div>
          </div>

          <div class="line row">
            <div class="col-md-2 col-sm-2">
              <fg-input v-model="specification_info.start_date" type="text" :label="translate('specification.start_date')"
                        :placeholder="translate('specification.start_date')" :readonly="true" />
            </div>

            <div class="col-md-2 col-sm-2">
              <WrapDatePicker
                  type="date"
                  value_type="YYYY-MM-DD"
                  :placeholder="translate('specification.planned_finish_date')"
                  :label="translate('specification.planned_finish_date')"
                  v-model="specification_info.planned_finish_date"
                  :range="false"
                  :confirm="false"
                  :clearable="false"
              />
            </div>

            <div class="col-md-2 col-sm-2">
              <fg-input v-model="date_closed" type="text" :label="translate('specification.closed_at')"
                        :placeholder="translate('specification.closed_at')" :readonly="true" />
            </div>
          </div>

          <div class="line row">
            <div class="col-md-12 col-sm-12 text_wrap">
              <div class="form-group">
                <label>{{ translate('specification.descr') }}</label>
                <textarea class="input_text" name="address" v-model="specification_info.descr" :rows="rows_4" />
              </div>
            </div>
          </div>

          <div class="line row">
            <div class="col-md-6 col-sm-6 text_wrap">
              <div class="form-group">
                <label>{{ translate('specification.comment') }}</label>
                <textarea class="input_text" name="address" v-model="specification_info.comment" :rows="rows_3" />
              </div>
            </div>

            <div class="col-md-6 col-sm-6 text_wrap">
              <div class="form-group">
                <label>{{ translate('specification.equipment') }}</label>
                <textarea class="input_text" name="address" v-model="specification_info.equipment" :rows="rows_3" />
              </div>
            </div>
          </div>

          <div class="line text-center buttons hide_for_print">
            <span v-if="has_changes" class="btn btn-success btn-fill btn-wd" @click.prevent="edit_specification">
              {{ translate('btn.edit') }}
            </span>
          </div>
        </div>

        <ItemsList
            :items_list="specification_info.items"
            :specification_id="specification_info.id"
            :has_client_orders="specification_info.has_client_orders"
            @update_info="update_info"
        />
      </div>

    </div>

    <div class="specification_info__right">
      <Summary type="specification" :info="specification_info" :view_history="false" />
    </div>
  </div>

</template>
<script>
import Summary from "components/UIComponents/Summary/Summary.vue";
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";
import ItemsList from "./ItemsList/ItemsList.vue";

const fields_to_check = ["cost", "spec_number", "name", "status", "planned_finish_date", "type", "descr", "comment", "equipment"];

export default {
  name: 'SpecificationInfo',
  components: {
    WrapDatePicker,
    Summary,
    ItemsList
  },

  props: {
    specification: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      specification_info: {},
      filter_asc: "asc",
      filter_type: ""
    }
  },

  created() {
    this.specification_info = JSON.parse(JSON.stringify(this.specification))
  },

  activated() {
    this.specification_info = JSON.parse(JSON.stringify(this.specification))
  },

  computed: {
    rows_3(){
      return this.specification_info.comment || this.specification_info.equipment ? '3' : '1'
    },
    check_status(){
      return this.specification.status > 1
    },
    rows_4(){
      return this.specification_info.descr ? '3' : '1'
    },
    date_created() {
      return this.specification.created_at ? this.get_date(this.specification.created_at) : ""
    },
    date_updated() {
      return this.specification.updated_at ? this.get_date(this.specification.updated_at) : ""
    },
    date_closed() {
      return this.specification.closed_at ? this.get_date(this.specification.closed_at) : ""
    },

    client_list(){
      return this.$store.getters.getClientsList.map((client) => {
        return { id: client.id, label: client.name }
      })
    },

    type_list(){
      return this.$store.getters.getClientOrderSpecs.types.map((type) => {
        return {label: type.descr, id: type.id}
      })
    },

    status_list(){
      return this.$store.getters.getClientOrderSpecs.statuses.map((status) => {
        return {label: status.descr, id: status.id}
      })
    },

    has_changes() {
      let main_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.specification[key];
        return obj;
      }, {});

      let specification_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.specification_info[key];
        return obj;
      }, {});

      return JSON.stringify(main_info) !== JSON.stringify(specification_info);
    }
  },

  watch: {
    specification(){
      this.specification_info = {...this.specification}
    }
  },

  methods: {
    update_info(){
      this.$emit('get_spec')
    },
    edit_specification() {
      let specification_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.specification_info[key];
        return obj;
      }, {});

      specification_info.cost = Number(specification_info.cost)

      this.$http.v1.putSpecificationInfo(this.specification_info.id, specification_info, (response) => {
        this.global_notify('info', this.translate('specification.saved_success'))
        this.specification_info = response.data
        this.$emit('update', response.data)
      })
    },
  }
}

</script>

<style lang='scss' scoped>
.specification_info {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  overflow: auto;

  @media (max-width: 991px) {
    flex-direction: column;
  }

  &__left {
    width: 70%;
    height: 100%;
    padding-right: 10px;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }

    .form_select{
      .form-control {
        width: 100%;
      }
    }

    .main_info{
      .form-group{
        position: relative;
        margin-bottom: 5px;
      }
      span.edit{
        font-size: 16px;
        &:hover{
          color: #41b883;
        }
      }
    }

    .response_table {
      height: auto;
      padding: 0;
      margin-bottom: 20px;

      .header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;

        .mdi{
          font-size: 10px;
          padding: 0;
        }
      }



      .status {
        width: 8%;
      }

      .tariffication {
        width: 20%;
      }

      .tariffication_on {
        background-color: #41b88370;
      }

      .tariffication_off {
        background-color: #ff000057;
      }

      .no_tariffication {
        background-color: transparent;
      }

      table {
        tbody {
          .online {
            color: #15ab00;
          }

          span.badge {
            font-size: 12px;
          }

          span {
            font-size: 20px;
          }
        }

        td {
          padding: 5px;
          p{
            margin: 0;
            font-size: 10px;
          }
          &.bad_sku{
            background-color: #ff000057;
          }
        }
      }
      .w70{
        width: 70px;
      }
      .w30{
        width: 30px;
      }
    }

    .rmodems{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      gap: 10px;
      p{
        text-wrap: nowrap;
      }
    }

    .buttons {
      .btn{
        margin-right: 10px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }

  &__right {
    width: 30%;
    height: 100%;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }
  }
}
</style>
